/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxSizeMB: NonNullable<unknown> }} Coinvestments_Dataroom_Dropzonehint4Inputs */

const en_coinvestments_dataroom_dropzonehint4 = /** @type {(inputs: Coinvestments_Dataroom_Dropzonehint4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`pdf, docx, xlsx, pptx • ${i?.maxSizeMB} MB max per file`)
};

/**
* | output |
* | --- |
* | "pdf, docx, xlsx, pptx • {maxSizeMB} MB max per file" |
*
* @param {Coinvestments_Dataroom_Dropzonehint4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_dropzonehint4 = /** @type {((inputs: Coinvestments_Dataroom_Dropzonehint4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Dropzonehint4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_dropzonehint4(inputs)
});
export { coinvestments_dataroom_dropzonehint4 as "coInvestments_dataRoom_dropZoneHint" }